import {Dropdown, DropdownMenu, DropdownItem} from '../dropdown';
import {Checkbox} from '../checkbox';
import {Radio} from '../radio';
import {isStringOrNumber, getRestProps, _$} from '../utils';
import Intact from 'intact';
import {Input} from '../input';
import {Icon} from '../icon';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const normalize = Intact.normalize;

let {
    title, key, group, multiple, ignore,
    sortable, $parent, _show, className, align,
    cols, rows, invisible, exportTitle, _keywords,
} = self.get();

const width = self.width;

const {sort, resizable, container} = $parent.get();
const groupText = group && self._getGroupText() || '';

const thTitle = isStringOrNumber(title) ? title + groupText : undefined;
title = normalize ? normalize(title) : title;

    return h('th', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'title': function() {try {return (thTitle )} catch(e) {_e(e)}}.call($this),
        'data-ignore': function() {try {return (ignore ? '' : undefined )} catch(e) {_e(e)}}.call($this),
        'colspan': function() {try {return (cols && cols > 1 && cols || undefined )} catch(e) {_e(e)}}.call($this),
        'rowspan': function() {try {return (rows && rows > 1 && rows || undefined )} catch(e) {_e(e)}}.call($this),
        'ev-click': function() {try {return (self.onClick )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (resizable )} catch(e) {_e(e)}}.call($this) ?
            h('div', {
                'data-text': function() {try {return (exportTitle )} catch(e) {_e(e)}}.call($this),
                'ev-mousedown': function() {try {return (self.onDragStart )} catch(e) {_e(e)}}.call($this),
                'ev-click': function() {try {return (self._stopPropagation )} catch(e) {_e(e)}}.call($this)
            }, null, 'k-resize') :
            undefined,
        h('div', {
            'data-text': function() {try {return (!resizable ? exportTitle : undefined )} catch(e) {_e(e)}}.call($this)
        }, [
            function() {try {return (!group )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, (_blocks['title'] = function(parent) {
                    return function() {try {return (title )} catch(e) {_e(e)}}.call($this);
                }) && (__blocks['title'] = function(parent) {
                    var args = arguments;
                    return blocks['title'] ? blocks['title'].apply($this, [function() {
                        return _blocks['title'].apply($this, args);
                    }].concat(__slice.call(args, 1))) : _blocks['title'].apply($this, args);
                }) && __blocks['title'].apply($this, [__noop]), 'c-ellipsis') :
                undefined,
            function() {try {return (group )} catch(e) {_e(e)}}.call($this) ?
                h('div', null, [
                    h(Dropdown, {
                        'container': function() {try {return (container )} catch(e) {_e(e)}}.call($this),
                        'trigger': 'click',
                        'children': [
                            h('i', null, null, 'k-arrow ion-ios-arrow-down'),
                            h(DropdownMenu, {
                                'className': _className(function() {try {return ({'k-table-dropdown': true, 'k-multiple': multiple} )} catch(e) {_e(e)}}.call($this)),
                                'children': [
                                    h('div', null, h(Input, {
                                        'fluid': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                                        'size': 'small',
                                        'placeholder': function() {try {return (_$('请输入关键字') )} catch(e) {_e(e)}}.call($this),
                                        'clearable': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                                        '_context': $this,
                                        '_blocks': function(blocks) {
                                            var _blocks = {}, __blocks = extend({}, blocks);
                                            return ((_blocks['suffix'] = function(parent) {
                                                return h(Icon, {
                                                    'className': 'ion-ios-search',
                                                    '_context': $this
                                                });
                                            }) && (__blocks['suffix'] = function(parent) {
                                                var args = arguments;
                                                return blocks['suffix'] ? blocks['suffix'].apply($this, [function() {
                                                    return _blocks['suffix'].apply($this, args);
                                                }].concat(__slice.call(args, 1))) : _blocks['suffix'].apply($this, args);
                                            }), __blocks);
                                        }.call($this, {}),
                                        'value': _getModel(self, '_keywords'),
                                        'ev-$change:value': function(__c, __n) { _setModel(self, '_keywords', __n, $this) }
                                    }), 'k-group-header'),
                                    h('div', null, __m(function() {try {return (group.filter(item => {
                                return String(item.value).includes(_keywords) ||
                                    String(item.label).includes(_keywords);
                            }) )} catch(e) {_e(e)}}.call($this), function(value, key) {
                                        return h(DropdownItem, {
                                            'className': _className(function() {try {return ({'k-active': self._isChecked(value.value)} )} catch(e) {_e(e)}}.call($this)),
                                            'hideOnSelect': function() {try {return (!multiple )} catch(e) {_e(e)}}.call($this),
                                            'key': function() {try {return (value.value )} catch(e) {_e(e)}}.call($this),
                                            'children': function() {try {return (multiple )} catch(e) {_e(e)}}.call($this) ?
                                                h(Checkbox, {
                                                    'name': 'key',
                                                    'value': function() {try {return (self._isChecked(value.value) )} catch(e) {_e(e)}}.call($this),
                                                    'children': function() {try {return (value.label )} catch(e) {_e(e)}}.call($this),
                                                    '_context': $this
                                                }) :
                                                h('span', null, function() {try {return (value.label )} catch(e) {_e(e)}}.call($this)),
                                            '_context': $this,
                                            'ev-select': function() {try {return (self._onSelect.bind(self, value.value) )} catch(e) {_e(e)}}.call($this)
                                        });
                                    }, $this), 'k-grou-body')
                                ],
                                '_context': $this,
                                'ev-$change:value': function() {try {return (self._onChangeShow )} catch(e) {_e(e)}}.call($this)
                            })
                        ],
                        '_context': $this
                    }),
                    h('div', null, [
                        (_blocks['title'] = function(parent) {
                            return function() {try {return (title )} catch(e) {_e(e)}}.call($this);
                        }) && (__blocks['title'] = function(parent) {
                            var args = arguments;
                            return blocks['title'] ? blocks['title'].apply($this, [function() {
                                return _blocks['title'].apply($this, args);
                            }].concat(__slice.call(args, 1))) : _blocks['title'].apply($this, args);
                        }) && __blocks['title'].apply($this, [__noop]),
                        function() {try {return (groupText )} catch(e) {_e(e)}}.call($this)
                    ], 'c-ellipsis')
                ], 'k-group') :
                undefined,
            function() {try {return (do {
            if (sortable) {
                const type = key === sort.key ? sort.type : '';
                h('div', null, h('i', null, null, _className(function() {try {return ({
                        'k-icon': true,
                        [`icon-${type}`]: type,
                        'icon-sortable': !type,
                    } )} catch(e) {_e(e)}}.call($this))), _className(function() {try {return ({'k-sort': true, [`k-${type}`]: type} )} catch(e) {_e(e)}}.call($this)))
            }
        } )} catch(e) {_e(e)}}.call($this)
        ], _className(function() {try {return ({"k-th": true, "k-group-show": _show} )} catch(e) {_e(e)}}.call($this)))
    ], _className(function() {try {return ({
        'k-sortable': sortable,
        [className]: className,
        [`k-${align}`]: align,
        'k-invisible': invisible,
    } )} catch(e) {_e(e)}}.call($this)))
}